// Client-side rejection of sessions that are clearly not member sessions.
// The Core stays the authority; this only prevents using a staff/team token in the member app.
const STAFF_WORDS = new Set(["staff", "admin", "owner", "superadmin", "control", "team", "ops", "operator"]);
const CLAIM_KEYS = ["role", "roles", "scope", "scopes", "aud", "kind", "type", "typ", "token_type", "account_type", "realm", "principal"];

function decodeJwtPayload(token) {
  const part = String(token || "").split(".")[1];
  if (!part) return null;
  try {
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "=");
    return JSON.parse(atob(b64));
  } catch (_) {
    return null;
  }
}

function staffMarked(obj, ignoreAud = false) {
  if (!obj || typeof obj !== "object") return false;
  if (obj.is_staff === true || obj.is_admin === true || obj.staff === true) return true;
  return CLAIM_KEYS.some((k) => !(ignoreAud && k === "aud") && [].concat(obj[k] ?? []).some((v) =>
    typeof v === "string" && v.toLowerCase().split(/[^a-z]+/).some((w) => STAFF_WORDS.has(w))));
}

export function memberProblem(member) {
  if (!member || typeof member !== "object" || !member.id) return "invalid_session";
  return staffMarked(member) ? "staff_account" : null;
}

// Session end: remove every Cache Storage entry (the service worker caches nothing; this is a safety net).
export function purgeCacheStorage(store = typeof caches === "undefined" ? null : caches) {
  if (!store) return Promise.resolve(0);
  return Promise.resolve()
    .then(() => store.keys())
    .then((keys) => Promise.all(keys.map((k) => store.delete(k))).then(() => keys.length))
    .catch(() => -1);
}

export function memberSessionProblem(data) {
  if (!data || typeof data.access_token !== "string" || !data.access_token || typeof data.refresh_token !== "string" || !data.refresh_token) return "invalid_session";
  const claims = decodeJwtPayload(data.access_token);
  // Core member tokens (type=member_access) carry the shared aud=FRONTEND_URL (e.g. the Control host); only then is aud no team marker.
  const memberAccess = claims !== null && typeof claims === "object" && claims.type === "member_access";
  return memberProblem(data.member) || (staffMarked(claims, memberAccess) ? "staff_account" : null);
}
